import { VscCheckAll } from "react-icons/vsc";
import { BiMap, BiPhoneCall } from "react-icons/bi";
import { AiOutlineMail } from "react-icons/ai";
import { FaFax } from "react-icons/fa";
import Card from "../../layout/Card";
import Master from "../../layout/Master";
import Sidbar from "../../layout/Sidbar";
import ItemsAboutUs from '../About/ItemsAboutUs'
import './style.css'
import BCButom from "../../Tools/BCButom";
const ContactUS = () => {
    return (
        <Master>
        <Sidbar>
            <div className="sliderContactUs">   
                <h1>راه های ارتباطی</h1>
            </div>
            <Card >
                <div className="containerBaxContactUs">
                    <div className="contactUsBoxRigth">
                        <h4>ساعات کاری کلینیک</h4>

                        <ul>
                            <li>
                            شنبه ۱۴:۰۰ - ۱۶:۰۰ (تهران) هماهنگی با اقای رضانژاد
                            </li>
                            <li>
                            یکشنبه ۱۰:۰۰ - ۱۲:۰۰ درمانگاه بیمارستان علوی
                            </li><li>
                            دوشنبه ۱۷:۰۰ - ۲۰:۰۰
                            </li><li>
                            سه شنبه ۱۷:۰۰ - ۱۸:۰۰ بیمارستان مادر
                            </li><li>
                            چهارشنبه ۱۷:۰۰ - ۲۰:۰۰
                            </li><li>
                            پنجشنبه تعطیل
                            </li><li>
                            جمعه تعطیل
                            </li><li>
                            رزرو نوبت اینترنتی
                            </li>
                        </ul>
                    </div>
                    <div className="contactUsBoxLeft">
                    <h4>نشانی</h4>
                    <ItemsAboutUs className="w-100 mt-0 me-0 ms-1" icon={<BiMap style={{color: "#e37a1d"}} />}>
                    مشهد، خیابان پاسداران، پاسداران ۳/۱، پلاک ۲۴
                        </ItemsAboutUs>
                        
                        <ItemsAboutUs className="w-100 mt-0 me-0 ms-1" icon={<BiPhoneCall style={{color: "#e37a1d"}} />}>
                        ۰۵۱-۳۲۲۳۸۷۰۸
                        </ItemsAboutUs>
                        <ItemsAboutUs className="w-100 mt-0 me-0 ms-1" icon={<BiPhoneCall style={{color: "#e37a1d"}} />}>
                        ۰۵۱-۳۲۲۳۸۷۰۹
                        </ItemsAboutUs>
                        <ItemsAboutUs className="w-100 mt-0 me-0 ms-1" icon={<FaFax style={{color: "#e37a1d"}} />}>
                        ۰۹۳۳۳۱۹۱۳۶۳
                        </ItemsAboutUs>
                        <ItemsAboutUs className="w-100 mt-0 me-0 ms-1" icon={<AiOutlineMail style={{color: "#e37a1d"}} />}>
                        info@modaghegh.com
                        </ItemsAboutUs>
                    </div>
                    <div className="sectionBTN">
                        <a href="https://app.minns.cloud/reservations/home/1" target={`_blank`}> <BCButom style={{paddingTop: "18px", paddingBottom: "18px", paddingRight: "30px", paddingLeft: "30px"}} className="btnOne" >مشاوره انلاین و ارتباط با پزشک </BCButom>    </a>
                    </div>
      
                    <div className="sectionMap">
                        <iframe   height='300' id='contactMap' src='https://maps.google.com/maps?q=36.28949411095911,59.59593718465607&z=14&ie=UTF8&iwloc=&output=embed' frameborder='0' scrolling='no' marginheight='0' marginwidth='0'></iframe>
                    </div>
                    
                </div>
            </Card>
                
        </Sidbar>
    </Master>
    )
}

export default ContactUS;